import { render, staticRenderFns } from "./EbooksRecent.vue?vue&type=template&id=0cb07d77&"
import script from "./EbooksRecent.vue?vue&type=script&lang=js&"
export * from "./EbooksRecent.vue?vue&type=script&lang=js&"
import style0 from "./EbooksRecent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports